import store from '../store';
import { COMPONENTS, FSM } from '../utils/constants.json';
import FSM_CONSTANTS from '../components/fseManagementSystem/utils/FSMContants';

/**
 * action - dispatch open drawer data in store.
 * @return {Object}
 */
export function openDrawer() {
  return {
    type: COMPONENTS.DRAWER.OPEN,
  };
}

/**
 * action - dispatch close drawer data in store.
 * @return {void}
 */
export function closeDrawer() {
  return {
    type: COMPONENTS.DRAWER.CLOSE,
  };
}
/**
 * action - dispatch show global loader data in store.
 * @override
 * @return {Object}
 */
export function showLoader(index, loaderMessage = '') {
  return {
    type: COMPONENTS.LOADER.SHOW,
    payload: { loaderIndex: index || 0, loaderMessage },
  };
}

/**
 * action - dispatch hide global loader data in store.
 * @override
 * @return {}
 */
export function hideLoader(index, loaderMessage = '') {
  return {
    type: COMPONENTS.LOADER.HIDE,
    payload: { loaderIndex: index || 0, loaderMessage },
  };
}

/**
 * action - dispatch open global modal data in store.
 * @return {Object}
 */
export function openModal(contentId = '') {
  return {
    type: COMPONENTS.MODAL.OPEN,
    payload: { contentId },
  };
}

/**
 * action - dispatch close global modal data in store.
 * @return {void}
 */
export function closeModal() {
  return {
    type: COMPONENTS.MODAL.CLOSE,
  };
}

export function isP4b() {
  const newState = store.getState();
  const appName = (newState && newState.fsm && newState.fsm.appName) || '';
  return appName === FSM_CONSTANTS.P4B;
}

export function success(data, type) {
  return {
    type,
    payload: data,
  };
}

export function switchStage(currentStage) {
  return (dispatch) => {
    dispatch(success(currentStage, FSM.HOMEPAGE.SUCCESS));
  };
}

export function switchPreviousStage(previousStage) {
  return (dispatch) => {
    dispatch(success(previousStage, FSM.HOMEPAGE.SUCCESS));
  };
}
